import {stringify} from 'querystring';
import set from 'lodash.set';
import {parse} from 'url';

export function searchArticles(query, params = {}) {
  const url = '/.netlify/functions/search';
  const querystring = stringify({...params, query});
  return fetch(`${url}?${querystring}`)
    .then(response => response.json())
    .then(json => json.articles);
}

const localizeResult = result => set(result, 'url', parse(result.url).path);

const localizeResults = results => results.map(localizeResult);

export function searchTypeahead(query) {
  const url = process.env.GATSBY_TYPEAHEAD_URL;
  const term = encodeURIComponent(query);
  return fetch(`${url}?query=${term}`)
    .then(response => response.json())
    .then(json => json.articles)
    .then(articles => articles.results)
    .then(localizeResults);
}



// WEBPACK FOOTER //
// ./src/lib/search.js